<script setup>
import AssetsSelect from '@/views/experimental/map-view/AssetsSelectModel.vue';
import { getBaseURL } from '@/config.js';
</script>
<template>
  <div>
    <div class="mt-5">
      <p>Key In <b>Receipt Information</b> and Proceed.</p>

      <label class="vs-input--label">Vehicle Select</label>
      <!-- <ejs-multiselect id="multiselect" :dataSource="fleets" v-model="receiptInfo.assetId" :fields="fields"
        popupHeight="400px" mode="CheckBox" :filtering="filtering" enableGroupCheckBox="true" showDropDownIcon="true"
        allowFiltering="true" filterType="contains" maximumSelectionLength="1" filterBarPlaceholder="Search"
        showSelectAll="false" placeholder="Select Assets" enableVirtualization="true"> </ejs-multiselect> -->

      <AssetsSelect
        v-model="receiptInfo.assetId"
        :dataSource="fleets"
        :style="{ width: `500px` }"
        :f="fields"
        :singleSelect="true"
      />

      <br>
      <label class="vs-input--label">Maintenance Vehicles</label>
      <!-- <ejs-multiselect id="multiselect2" :dataSource="fmsSelection" v-model="receiptInfo.fmsAssetId" :fields="fields2"
        popupHeight="400px" mode="CheckBox" :filtering="filtering" enableGroupCheckBox="true" showDropDownIcon="true"
        allowFiltering="true" filterType="contains" maximumSelectionLength="1" filterBarPlaceholder="Search"
        showSelectAll="false" placeholder="Select Assets" enableVirtualization="true"> </ejs-multiselect> -->

      <AssetsSelect
        v-model="receiptInfo.fmsAssetId"
        :dataSource="fmsSelection"
        :style="{ width: `500px` }"
        :filtering="filtering"
        :f="fields2"
        :singleSelect="true"
      />


      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input label="Total Price (RM)" v-model="receiptInfo.price" class="w-full mt-4" />
        </div>
        <div class="vx-col md:w-1/2 w-half">
          <vs-input label="Volume (Litres)" v-model="receiptInfo.fuel" class="w-full mt-4" />
        </div>

      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input label="Price / Liter (RM)" v-model="receiptInfo.priceperliter" class="w-full mt-4" />
        </div>
        <div class="vx-col md:w-1/2 w-half">
          <vs-input label="Location" v-model="receiptInfo.location" class="w-full mt-4" />
        </div>

      </div>
      <br></br>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input type="datetime-local" label="Time" v-model="receiptInfo.time" class="w-full mt-4" />
        </div>
        <div class="vx-col md:w-1/2 w-half">
          <vue-dropzone ref="vehicleImages" id="dropzone" :options="dropzoneOptions"
            v-on:vdropzone-success="vehicleDocumentsUpload"
            v-on:vdropzone-removed-file="vehicleDocumentsRemove"></vue-dropzone>
          <vs-list-item v-for="(file, i) in receiptInfo.files" icon="description" :key="i" :title="file"
            :subtitle="`File ${i + 1}`"></vs-list-item>
        </div>
        <!--       <div class="vx-col md:w-1/2 w-half">
                Attachment/Receipts
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="vehicleDocumentsUpload($event,indextr)"  v-on:vdropzone-removed-file="vehicleDocumentsRemove($event,indextr)"></vue-dropzone>
               </div>    -->
      </div>
      <br></br>
      <vs-button color="primary" @click="submitDetails()">Add Receipt</vs-button> &nbsp;
    </div>
    <br>
    <hr>
    <div class="mt-5">
      <h5>Bulk Import Receipts</h5>
      <p>Step 1 : <b><a href="https://api.igeotechgps.com/uploads/%5BTEMPLATE%5D%20Upload%20Fuel%20%26%20Toll%20Receipt.xlsx" target="blank">Click to Download</a> Excel template.</b></p>
      <p>Step 2 : <b>Fill up the excel template with the receipts data as per the guidelines & upload to import.</b></p>

      <label class="vs-input--label">Upload DATA file </label>
      <input type="file" ref="fileInput" @change="csvToJSON($event)"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
      <br><br>
      <label>Overwrite Existing Data? Select YES to overwrite any existing data. SELECT NO to combine multiple different
        files without overwriting existing data.</label>
      <vs-switch v-model="overwrite" size="sm">
        <span slot="on">YES</span>
        <span slot="off">NO</span>
      </vs-switch>
      <br>
      <vs-table stripe :data="receipts" maxHeight="40vh">
        <template slot="thead">
          <vs-th width="5%">No.</vs-th>
          <vs-th>Asset</vs-th>
          <vs-th>Asset from Maintenance Record?</vs-th>
          <vs-th>Refuel Volume (L)</vs-th>
          <vs-th>Price per Liter (RM)</vs-th>
          <vs-th>Total Price (RM)</vs-th>
          <vs-th>Time of Refuel</vs-th>
          <vs-th>Location</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>
                <b>{{ indextr + 1 }}.</b></span>
            </vs-td>
            <vs-td>
              <span>{{ receipts[indextr].assetName }}</span>
            </vs-td>
            <vs-td>
              <span>{{ receipts[indextr].maintenanceRecord }}</span>
            </vs-td>
            <vs-td>
              <span>{{ receipts[indextr].fuel }}</span>
            </vs-td>
            <vs-td>
              <span>{{ receipts[indextr].priceperliter }}</span>
            </vs-td>
            <vs-td>
              <span>{{ receipts[indextr].price }}</span>
            </vs-td>
            <vs-td>
              <span>{{ receipts[indextr].time }}</span>
            </vs-td>
            <vs-td>
              <span>{{ receipts[indextr].location }}</span>
            </vs-td>
            <vs-td>
              <vs-button color="danger" type="border" icon-pack="feather" icon="icon-trash"
                @click="removeData(indextr)"></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br></br>
      <vs-button color="primary" @click="submitBulkDetails()">Add Bulk Receipts</vs-button> &nbsp;
    </div>
  </div>
</template>

<script>

import { FormWizard, TabContent } from 'vue-form-wizard'
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns'
import { Query, Predicate } from '@syncfusion/ej2-data'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vSelect from 'vue-select'
import { Workbook } from 'exceljs';

export default {
  props: {
    fleets: Array,
    fmsSelection: Array
  },
  data() {
    return {
      overwrite: false,
      receipts: [],
      quickSelect: null,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue: true,
      loadingWizard: false,
      errorMsg: null,
      fleetAlarm: [],
      fleetNotification: [],
      fleetNotificationConfig: [30, 14, 3],
      fields: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      fields2: { groupBy: 'assetGroup', text: 'assetName', value: 'fmsAssetId' },
      receiptInfo: {
        assetId: null,
        fmsAssetId: null,
        fuel: 0,
        priceperliter: 0,
        price: 0,
        time: '',
        location: '',
        files: []

      },
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 10,
        addRemoveLinks: true
        //autoProcessQueue: false
      },
    }
  },
  watch: {

  },
  methods: {
    getArray(objArray) {
      let arr = [];
      objArray.forEach((element, i) => {
        let internalArr = [];
        internalArr.push(element.fmsAssetId);
        internalArr.push(element.assetId);
        internalArr.push(element.fuel);
        internalArr.push(element.priceperliter);
        internalArr.push(element.price);
        internalArr.push(element.time);
        internalArr.push(element.location);
        internalArr.push(element.files);
        internalArr.push(element.uid);
        arr.push(internalArr);
      })
      return arr;
    },
    searchFMSUnit(name) {
      const self = this;
      return self.fmsSelection.find(item => item.name === name);
    },
    searchGPSUnit(name) {
      const self = this;
      return self.fleets.find(item => item.assetName === name);
    },
    removeData(index) {
      this.receipts.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Record',
        color: 'success',
      });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async csvToJSON(event) {
      const self = this;
      const file = event.target.files.item(0);
      await self.validateExcelFile(file);
    },
    async validateExcelFile(file) {
      const self = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;
          const workbook = new Workbook();
          workbook.xlsx
            .load(buffer)
            .then(() => {
              if (self.overwrite == true) {
                self.receipts = [];
              }
              const fuelReceiptWorksheet = workbook.getWorksheet(2);
              fuelReceiptWorksheet.eachRow(function (row, rowNumber) {
                if (rowNumber > 5) {
                  let fmsAssetId = null;
                  let assetId = null;
                  let assetName = "";
                  if (row.values[2] == 'YES' || row.values[2] == 'yes') {
                    fmsAssetId = self.searchFMSUnit(row.values[1]).fmsAssetId;
                    assetName = self.searchFMSUnit(row.values[1]).assetName;
                  }
                  else {
                    assetId = self.searchGPSUnit(row.values[1]).assetId;
                    assetName = self.searchGPSUnit(row.values[1]).assetName;
                  }
                  let time = self.formatDate(row.values[6]);
                  self.receipts.push({
                    fmsAssetId: fmsAssetId,
                    assetId: assetId,
                    assetName: assetName,
                    maintenanceRecord: row.values[2],
                    fuel: Number(row.values[3]),
                    priceperliter: Number(row.values[4]),
                    price: Number(row.values[5]),
                    time: time,
                    location: row.values[7],
                    files: JSON.stringify([]),
                    uid: self.userInfo.uid
                  });
                }
              });

            }).catch((error) => {
              reject('Error occurred while loading the workbook.');
            }).finally(() => {
              self.$refs.fileInput.value = '';
            });
        };
      });
    },
    vehicleDocumentsUpload(event, index) {
      const x = JSON.parse(event.xhr.response).path
      const str = x.substring(25)
      this.receiptInfo.files.push('https://api.igeotechgps.com/uploads/' + str)

    },
    vehicleDocumentsRemove(event, index) {
      const self = this
      const removedFile = event.upload.filename
      const arr = self.receiptInfo.files
      if (arr.length == 1) {
        self.receiptInfo.files = []
        return
      }
      arr.forEach((element, i) => {
        const y = element.split('_', 4)
        if (y[3].includes(removedFile)) {
          self.receiptInfo.files.splice(i, 1)
        }
      })
    },
    submitDetails() {
      const self = this
      if ((!self.receiptInfo.assetId && !self.receiptInfo.fmsAssetId) || self.receiptInfo.fuel < 1 || self.receiptInfo.price < 1 || self.receiptInfo.time == '') {
        return self.$vs.notify({
          title: 'Error',
          text: 'Asset,Volume,Price & Time are required fields.',
          iconPack: 'feather',
          icon: 'icon-refresh-cw',
          color: 'warning'
        })
      }
      console.log(self.receiptInfo)
      if ((self.receiptInfo.assetId != null && self.receiptInfo.fmsAssetId != null)) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select Either from Vehicle / Maintenance Asset list only.',
          iconPack: 'feather',
          icon: 'icon-refresh-cw',
          color: 'warning'
        })
      }
      self.$http.post('receipts/submit', {
        userInfo: self.userInfo,
        receiptInfo: self.receiptInfo
      })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.$emit('exit', true)
            return self.$vs.notify({
              title: 'New record added',
              text: 'Receipt info added!',
              iconPack: 'feather',
              icon: 'icon-refresh-cw',
              color: 'success'
            })

          } else {
            self.$emit('exit', true)
            if (response.data.error) {

              return self.$vs.notify({
                title: 'Error',
                text: response.data.error,
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            } else {

              return self.$vs.notify({
                title: 'Error',
                text: 'Could not created FMS Receipt record at this time.Try again later.',
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            }
          }
        })
        .catch(function (error) {
          self.$emit('exit', true)
        })
    },
    submitBulkDetails() {
      const self = this
      if (self.receipts.length < 1) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Add at least 1 record to continue',
          iconPack: 'feather',
          icon: 'icon-refresh-cw',
          color: 'warning'
        })
      }
      let receiptsArray = self.getArray(self.receipts);
      self.$http.post('receipts/submit-bulk', {
        userInfo: self.userInfo,
        receipts: receiptsArray
      })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.$emit('exit', true)
            return self.$vs.notify({
              title: 'New records added',
              text: 'Receipts info added!',
              iconPack: 'feather',
              icon: 'icon-refresh-cw',
              color: 'success'
            })

          } else {
            self.$emit('exit', true)
            if (response.data.error) {

              return self.$vs.notify({
                title: 'Error',
                text: response.data.error,
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            } else {

              return self.$vs.notify({
                title: 'Error',
                text: 'Could not created FMS Receipt record at this time.Try again later.',
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            }
          }
        })
        .catch(function (error) {
          self.$emit('exit', true)
        })
    }

  },
  mounted() {

  },
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect
  }
}
</script>

<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";

.e-multiselect {
  border-bottom: 1px solid #ffffff;
  font-family: "Montserrat";
}

.e-multi-select-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  font-family: "Montserrat";
  height: 40px;
}

.e-multi-select-wrapper-e-delimiter {
  font-family: "Montserrat";
}

.error {
  color: 'red';
  font-weight: 'bold';
  font-size: '20px'

}

.vs-table {
  overflow-y: visible !important;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
